/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { getValuesFromMultipleCheckboxesGrouped } from '@/utils/forms'

export const numbersArrayToStringsArray = (array) => {
  return array?.length > 0
    ? array.map(id => `${id}`)
    : []
}

export const setGeographiesOrder = (geographies) => {
  const currentGeographies = []

  if (geographies.length) {
    geographies.forEach(geography => {
      geography.alpha2Code !== 'US'
        ? currentGeographies.push(geography)
        : currentGeographies.unshift(geography)
    })
  }

  return currentGeographies
}

export const getAllTagIds = (companies) => {
  let currentIds = []

  if (companies?.length > 0) {
    const currentSelections = companies.map(company => {
      return company.llmTags.map(tag => tag.id)
    })

    currentIds = currentSelections.flat()
  }

  return currentIds
}

export const allUncheckedState = {
  allChecked: false,
  isIndeterminate: false
}

export const allCheckedState = {
  allChecked: true,
  isIndeterminate: false
}

export const calculateSelectAllState = (selectedIds, totalCount) => {
  if (!selectedIds || selectedIds.length === 0) {
    return allUncheckedState
  }

  if (selectedIds.length === totalCount) {
    return allCheckedState
  }

  return { allChecked: false, isIndeterminate: true }
}

export const handleSelectAll = ({ action, ids, setSelectAllState }) => {
  let newValue = []

  if (action === 'all') {
    newValue = ids.map(id => String(id.id || id))

    setSelectAllState(allCheckedState)
  } else if (action === 'none') {
    newValue = []

    setSelectAllState(allUncheckedState)
  }

  return newValue
}

export const handleCheckboxesGroupsChanges = (inputKey, groups, setFormValue) => {
  const ids = getValuesFromMultipleCheckboxesGrouped(groups)
  const currentValues = ids.length > 0
    ? ids
    : undefined

  setFormValue &&
    setFormValue(inputKey, currentValues, {
      shouldValidate: true
    })

  return ids
}
